import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
export interface Country{
  _id:number,
  locate?:string,
  title:string,
  code:string,
  flagIcon?:string
}

export interface State {
  country: Country[] | null,
  loadStatus: boolean
}

const defaultState: State = {
  country: null,
  loadStatus: false
};

const getters = {
  country: (state: State):Country[] | null => state.country,
  loadStatus: (state: State):boolean => state.loadStatus
}

const mutations: MutationTree<State> = {
  setCountry(state: State, payload: any[]) {
    state.country = payload
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loadStatus = payload
  }
}

const actions: ActionTree<State, RootState> = {
   async loadCountryFromServer({commit, state}) {
    if (state.country == null) {
      commit('setLoadStatus', true)
      try {
        const {data} = await Vue.axios.get('/v4/countries')
        commit('setCountry', data)
        // this.commit('alerts/setAlert',{
        //   show:true,
        //   messages:['Страны загружены']
        // })
      }catch (e) {
        console.log(e.message)
        this.commit('alerts/setAlert',{
          show:true,
          color:'red',
          messages:[e.message]
        })
      }
      commit('setLoadStatus', false)
    }
  },
   async loadCountryFromServerHard({commit, state}) {
      try {
        const {data} = await Vue.axios.get('/v4/countries')
        commit('setCountry', data)
      }catch (e) {
        console.log(e.message)
        this.commit('alerts/setAlert',{
          show:true,
          color:'red',
          messages:[e.message]
        })
      }
      commit('setLoadStatus', false)

  },

}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
